import Bugsnag from "@bugsnag/js";

function notifyBugsnag(error: Error) {
  Bugsnag.notify(error);
}

export default notifyBugsnag;
